import * as algolia from './algolia'
import * as app from './app'
export default { ...algolia, ...app }